// AUTOGENERATED FILE. DO NOT EDIT.

export default {
  "general": {
    "ok": "Ok"
  }
} as const;
